import {
  createContext,
  useState,
  ReactNode,
  useMemo,
  useContext,
  Dispatch,
  SetStateAction,
} from 'react'
import { SelectOption } from '~/shared/ui'
import { OptionsToBeLeftModel } from '../../crud/new-options-modal/types'

interface ProductOptionsContextType {
  optionsToBeLeft: OptionsToBeLeftModel[]
  setOptionsToBeLeft: (options: OptionsToBeLeftModel[]) => void
  optionsToBeLeftValue: Record<string, SelectOption>
  setOptionsToBeLeftValues: Dispatch<
    SetStateAction<Record<string, SelectOption>>
  >
  openRemoveOptionModal: boolean
  setOpenRemoveOptionModal: (open: boolean) => void
}

export const ProductOptionsContext = createContext<
  ProductOptionsContextType | undefined
>(undefined)

interface ProductOptionsProviderProps {
  children: ReactNode
}

export const ProductOptionsProvider = ({
  children,
}: ProductOptionsProviderProps) => {
  const [optionsToBeLeft, setOptionsToBeLeft] = useState<
    OptionsToBeLeftModel[]
  >([])
  const [optionsToBeLeftValue, setOptionsToBeLeftValues] = useState<
    Record<string, SelectOption>
  >({})
  const [openRemoveOptionModal, setOpenRemoveOptionModal] = useState(false)

  const contextValue = useMemo(
    () => ({
      optionsToBeLeft,
      setOptionsToBeLeft,
      optionsToBeLeftValue,
      setOptionsToBeLeftValues,
      openRemoveOptionModal,
      setOpenRemoveOptionModal,
    }),
    [optionsToBeLeft, optionsToBeLeftValue, openRemoveOptionModal],
  )

  return (
    <ProductOptionsContext.Provider value={contextValue}>
      {children}
    </ProductOptionsContext.Provider>
  )
}

export const useProductOptionsContext = () => {
  const context = useContext(ProductOptionsContext)

  if (!context) {
    throw new Error(
      'useProductOptionsContext must be used within a ProductOptionsProvider',
    )
  }

  return context
}
